
// SVG Icon: left-small
export default { id: "terriajs-left-small" };
export const id = "terriajs-left-small";
export const name = "left-small";
